<template>
  <div :style="containerStyle">
    <div :style="topContainerStyle">
      <div :style="panelContainerStyle">
        <template v-if="showPanel">
          <AggregatedSkillsPanel @disable-auto-camera-orbit="() => { disableAutoCameraOrbit = true; }"
                                 @enable-auto-camera-orbit="() => { disableAutoCameraOrbit = false; }"
                                 @hide-panel="() => { showPanel = false }" />
        </template>
        <template v-else>
          <div :style="mutedButtonStyle"
               @click="() => { showPanel = true }">
            Show panel &#x2192;
          </div>
        </template>
      </div>
    </div>
    <div ref="skillGraphContainer"
         :style="skillGraphContainerStyle">
      <template v-if="tenantSkillsLoaded && tenantSkillEdgesLoaded">
        <SkillGraph3dPrimary cursorOnHover="pointer"
                             :disableAutoCameraOrbit="disableAutoCameraOrbit"
                             :height="graphHeight"
                             :hideLabel="true"
                             :links="tenantSkillEdges"
                             :nodes="tenantSkills"
                             :width="graphWidth"
                             @double-click-node="searchExpertBySkill" />
      </template>
      <template v-else>
        <div :style="loaderContainerStyle">
          <LoaderPrimary :loading="true"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import AggregatedSkillsPanel from '@skill-explorer/modules/aggregated-skills-panel'
  import LoaderPrimary from '@modules/loader/loader-primary'
  import SkillGraph3dPrimary from '@modules/graph/skill-graph-3d-primary'
  import { Layout } from '@js/styles'
  import { Z_INDEXES } from '@js/constants'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'AggregatedSkillsViewer',
    components: {
      AggregatedSkillsPanel,
      LoaderPrimary,
      SkillGraph3dPrimary,
    },
    data: function () {
      return {
        containerStyle: {
          flex: 1,
          position: 'relative',
          width: '100%',
        },
        disableAutoCameraOrbit: false,
        graphHeight: null,
        graphWidth: null,
        loaderContainerStyle: {
          height: '100%',
        },
        mutedButtonStyle: {
          cursor: 'pointer',
        },
        panelContainerStyle: {
          zIndex: Z_INDEXES.SKILL_EXPLORER.CONTROL_PANEL,
        },
        showPanel: true,
        skillGraphContainerStyle: {
          height: '100%',
          left: 0,
          position: 'absolute',
          top: 0,
          width: '100%',
        },
        topContainerStyle: {
          alignItems: 'flex-start',
          display: 'flex',
          justifyContent: 'space-between',
          padding: `${Layout.space.md} ${Layout.space.lg}`,
          width: '100%',
        },
      };
    },
    created: function () {
      this.containerStyle = {
        ...this.containerStyle,
        backgroundColor: this.color.dark1(),
      };
    },
    mounted: function () {
      this.graphHeight = this.$refs.skillGraphContainer.clientHeight;
      this.graphWidth = this.$refs.skillGraphContainer.clientWidth;
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      ...mapGetters(
        'aggregatedSkills', ['tenantSkillsLoaded', 'tenantSkillEdgesLoaded']),
      ...mapState({
        tenantSkills: state => state.aggregatedSkills.tenantSkills,
        tenantSkillEdges: state => state.aggregatedSkills.tenantSkillEdges,
        windowHeight: state => state.window.height,
        windowWidth: state => state.window.width,
      }),
      tenantSkillEdges2: function () {
        if (!this.tenantSkillEdgesLoaded || !this.tenantSkillsLoaded) {
          return [];
        } else {
          const ret = this.tenantSkillEdges.reduce((result, elem) => {
            result.push(elem);
            result.push({ source: elem.target, target: elem.source });
            return result;
          }, []);
          return ret;
        }
      },
    },
    methods: {
      searchExpertBySkill: function (node) {
        if (node.name.length > 0) {
          this.$router.push({
            name: 'search',
            query: {
              by: 'skill',
              tag: node.name,
            },
          });
        }
      },
    },
    watch: {
      windowHeight: function (newVal, oldVal) {
        this.graphHeight = this.$refs.skillGraphContainer.clientHeight;
      },
      windowWidth: function (newVal, oldVal) {
        this.graphWidth = this.$refs.skillGraphContainer.clientWidth;
      },
    },
  };
</script>
